import type { TFunction } from 'i18next'

import fastEq from 'fast-deep-equal'
import memoizeOne from 'memoize-one'

import { getAnchorsTypesChoices } from '@/entities/anchor'
import { unwrapLines } from '@/entities/assortment'

export const generateFamilyId = () =>
	String(Math.floor(Math.random() * 1000000))
export const linesToProducts = memoizeOne(unwrapLines, fastEq)

export const getAnchorTypesOptions = (t: TFunction) =>
	getAnchorsTypesChoices(t).map((item) => ({
		...item,
		description: t(`app.${item.value}_anchor.description`),
	}))
